import React, { useEffect, useState } from 'react';
import { cpf } from 'cpf-cnpj-validator';
import { getCitiesBrazil } from '../../../services/LocationService'


import RecordMic from '../../RecordMic';
import Select from '../../Form/Select';
import Input from '../../Form/Input';


interface TypeSelectData {
  _id: string,
  name: string,
}

interface TypeProps {
  handleSelectChange: Function,
  handleInputChange: Function,
  nameCPF: string,
  valueCPF: string,
  nameNome: string,
  valueNome: string,
  nameUF: string,
  valueUF: string,
  nameCidade: string,
  valueCidade: string,
  nameRelato: string,
  valueRelato: string,
}

export default function FormEntrevista({
  handleInputChange,
  handleSelectChange,
  nameCPF,
  valueCPF,
  nameNome,
  valueNome,
  nameUF,
  valueUF,
  nameCidade,
  valueCidade,
  nameRelato,
  valueRelato
}: TypeProps) {

  const [listUF, setListUF] = useState<TypeSelectData[]>([])
  const [listCities, setListCities] = useState<any[]>([])

  useEffect(() => {
    const listCitiesData = getCitiesBrazil();

    // filtra UF distintas e formata para o padrao do combo select
    const listUFNew =
      listCitiesData
        .map(i => i.uf)
        .filter((el, i, arr) => arr.indexOf(el) == i)
        .map(i => { return { '_id': i, 'name': i } })

    setListUF(listUFNew)
    setListCities(listCitiesData)
  }, [])

  return (
    <>
      <Input
        name={nameCPF}
        label="CPF do entrevistado"
        type="text"
        placeholder={'CPF do entrevistado'}
        data={valueCPF || ''}
        setData={handleInputChange}
        className={cpf.isValid(valueCPF) ? 'inputSuccess' : 'inputError'}
      />
      <Input
        name={nameNome}
        label="Nome do entrevistado"
        type="text"
        placeholder={'Nome do entrevistado'}
        data={valueNome || ''}
        setData={handleInputChange}
      />
      <Select
        title={"UF"}
        data={listUF}
        value={valueUF}
        setSelected={(value: string) => { handleSelectChange(nameUF, value) }}
      />
      <Select
        title="Cidade do entrevistado"
        data={
          listCities
            .filter((i: any) => i.uf === valueUF)
            .map((i: any) => { return { _id: i.cidade, name: i.cidade } })
        }
        value={valueCidade}
        setSelected={(value: string) => { handleSelectChange(nameCidade, value) }}
      />
      <RecordMic
        title='Relato'
        name={`rec_${nameRelato}`}
        data={valueRelato}
        setData={(value: string) => {
          handleSelectChange(nameRelato, value)
        }}
      />

    </>
  )

}
